import { Component, Input, OnInit, input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * TODO reconsider this name, now Bizcuit is gone - either rename or merge with the regular Button component
 */
@Component({
  selector: 'BizcuitButton',
  imports: [CommonModule],
  template: `
    @if (href) {
      <a href="{{ href }}"
         target="{{ target() }}"
         rel="{{ rel() }}"
         class="{{ classes.join(' ') }}">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    } @else {

      @if (!submit) {
        <div class="{{ classes.join(' ') }}">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
      } @else {
        <button type="submit" [disabled]="disabled()" style="{{ style }}" class="{{ classes.join(' ') }}"
                [style.opacity]="disabled() ? .4 : 1">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </button>
      }
    }

    <ng-template #submit>
      <button type="submit" [disabled]="disabled()" style="{{ style }}" class="{{ classes.join(' ') }}"
              [style.opacity]="disabled() ? .4 : 1">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </button>
    </ng-template>

    <ng-template #content>
      <ng-content></ng-content>
    </ng-template>
  `
})
export class BizcuitButton implements OnInit {
  readonly submit = input(false);
  readonly disabled = input(false);
  readonly target = input("_self");
  readonly color = input<any>();
  @Input() href = '';
  readonly rel = input('opener');
  readonly outline = input(true);

  style: string;
  classes: string[] = [
    'my-button text-white w-full'
  ];

  ngOnInit() {
    if (this.outline()) {
      this.classes.push('sm:w-[317px] flex items-center justify-center text-center px-3 sm:px-6 rounded-2xl text-[17px] font-semibold py-[11px]');
      this.style = `background-color: ${this.color()}`;
    } else {
      this.classes.push('text-end uppercase text-[15px] font-medium');
      this.style = `color: ${this.color()}`;
    }
  }
}
